import { useQuery } from '@tanstack/react-query';
import { profileService, type ProfilePhotoResponse } from '../services/profileService';

export const useProfilePhoto = (enabled = true) => {
  return useQuery<ProfilePhotoResponse>({
    queryKey: ['profilePhoto'],
    queryFn: profileService.getPhoto,
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
    retry: 1,
    enabled,
  });
};
